import Avatar from './Avatar'

export default Avatar



// WEBPACK FOOTER //
// ./src/components/Avatar/index.js